import { BaseSettings, BaseThemeType } from 'Shared/frontend/themes/BaseSettings';
import { Questrial } from 'Shared/frontend/fonts/Questrial';
import { merge } from 'Shared/common/merge';
import { DeepPartial } from 'Shared/frontend/SettingsProvider';
import { INav } from 'Common/config/INav';
import { Contact } from 'Shared/frontend/icons/Contact';
import {Calendar} from 'Shared/frontend/icons/Calendar';
import {FoodMenu} from 'Shared/frontend/icons/FoodMenu';
import {Home} from 'Shared/frontend/icons/Home';
import {PeopleCircle} from 'Shared/backend/icons/PeopleCircle'; 
import { fluidType } from 'Shared/common/FluidType';
import { NavSchema } from 'Shared/frontend/nav/navSchema';


export class TheTownieSettings extends BaseSettings
{
	palette()
	{
		return {
			background: '#000000', //was //'#1B2126',
			text: '#E2E2E2',
			feature: '#DAB670',
			/* Eg the mobile nav colour */
			dimBackground: '#0D0D0D', // was//'#2E3234',

//XXX cf making these feature2, feature3, ... These names esp cactus are too specific
			food: '#B3462B',
			drinks: '#DAB670',
			cactus: '#5C905C'
		};
	}

	fontIncludes()
	{
		return [ Questrial ];
	}

	fonts()
	{
		return {
			text: 'Questrial, sans-serif',
			heading: 'sans-serif',
			buttons: 'Questrial, sans-serif',
			desktopNav: 'sans-serif',
			mobileNav: 'Questrial, sans-serif',
			subNav: 'Questrial, sans-serif',
		};
	}

//TODO add to ThemeProvider?
	text()
	{
		return merge(super.text(), {
			pageTitle: {
				color: this.palette().feature,
				fontWeight: 500,
				lineHeight: 1.3,
				textTransform: 'uppercase',
			},
			title: {
				color: this.palette().feature,
				fontWeight: 500,
				lineHeight: 1.3,
				fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,40,80),
				textTransform: 'uppercase',
				margin: '2em 0 1em 0',
			},
			tagline: {
				fontWeight: 700,
				textTransform: 'uppercase',
				letterSpacing: 2.2,
				margin: '1em 0',
			},
			paragraphTitle: {
			},
			plain: {
			},
		});
	}

	poster()
	{
		return merge(super.poster(), {
			shared: {
				root: {
					backgroundColor: this.palette().dimBackground,
					color: this.palette().feature,
				}
			}
		});
	}

	nav() {
		const sizes = this.sizes();

		return merge(super.nav(), {
			desktop: <Partial<NavSchema>> {
				settings: {
					button: {
						fontSize: fluidType('px',sizes.endFontShrink, sizes.minDesktopWidth,16,25),
					}
				}
			}
		});
	}

	page()
	{
		const palette = this.palette();

		return merge(super.page(), {
			widgets: {
				subNav: {
					button: {
						borderRadius: '0.4em'
					}
				},
			},
			button: {
				borderRadius: 6,
				backgroundColor: palette.dimBackground
			},
			embeddedHtml: {
				strong: {
					fontFamily: 'REM, sans-serif'
				}
			}
		});
	}

	subNavButton()
	{
		return {
			...super.subNavButton(),
			borderRadius: '0.4em',
		};
	}

	siteTheme()
	{
		const base = super.siteTheme();
		const palette = this.palette();

		const settings = merge(base, <DeepPartial<BaseThemeType>> {
			event: {
				subNav: {
					button: {
						backgroundColor: palette.feature,
						color: palette.background,
						fontSize: '0.8em',
						padding: '0.5em'
					}
				},
				artist: {
					heading: {
						color: palette.feature,
						fontFamily: 'sans-serif'
					},
					wide: {
						nameAndTime: {
							color: palette.feature
						}
					},
					narrow: {
						nameAndTime: {
							backgroundColor: palette.feature
						}
					}, 
					genresAndLocation: {
						color: palette.feature
					} 
				}
			},

			menu: {
				subNav: {
					button: {
						color: palette.background
					},
					buttonType: type => ({ backgroundColor: menuNavButtonColour(palette,type) })
				},

				title:(level:number,productType,section) => {
					return {
						...base.menu.title(level,productType,section),
						color: menuItemTitleColour(palette,productType,section)
					}
				},

				item: {
					background: 'red',
					title: {
						fontWeight: 'bold',
					},
					titleType: (productType,section) => ({color: menuItemTitleColour(palette,productType,section)}),
				}
			},
		});

		// XXX if we want to entirely remove or overwrite a base setting or two then do so here 
		return settings;
	}

	pages()
	{
		return [
//TODO maybe put home & hire in BaseSettings?
			{
				key: 'home',
				frontend: {
					route: '/',
					metaTitle: 'Home'
				},
				backend: {
					route: '/home',
					title: 'Home'
				}
			},
			{
				key: 'events',
				frontend: {
					route: '/events',
					metaTitle: 'Events'
				},
				backend: {
					route: '/events-design',
					title: 'Events'
				}
			},
			{
				key: 'hire',
				frontend: {
					route: '/hire',
					metaTitle: 'Hire'
				},
				backend: {
					route: '/hire',
					title: 'Hire'
				}
			},
			{
				key: 'contact',
				frontend: {
					route: '/contact',
					metaTitle: 'Contact'
				},
				backend: {
					route: '/contact',
					title: 'Contact'
				}
			},
			{
				key: 'club',
				frontend: {
					route: '/members',
					metaTitle: 'Club'
				},
				backend: {
					route: '/members',
					title: 'Club Townie'
				}
			},
			{
				key: 'reservation',
				frontend: {
					route: '/reservation',
					metaTitle: 'Reservation'
				},
				backend: {
					route: '/reservation',
					title: 'Reservation'
				}
			},
			{
				key: 'hireEnquiry',
				frontend: {
					route: '/hire-enquiry',
					metaTitle: 'Hire Enquiry'
				},
				backend: {
					route: '/hire-enquiry',
					title: 'Hire enquiry'
				}
			},
		];
	}

	navContent(): INav
	{
		return {
			desktop: [
				{label:'Home',		link:'frontend/Home'},
				{label:'Menus',		link:'frontend/Menu'},
				{label:'Events',	link:'frontend/Events'},
				{label:'Hire',		link:'frontend/Hire'},
				{label:'Club',		page:'club'},
				{label:'Contact',	link:'frontend/Contact'},
			],
			mobile: {
				maxButtons: 5,
				includeMoreButton: true,
				links: [
					{label:'Home',		link:'frontend/Home',		icon:Home},
					{label:'Menus',		link:'frontend/Menu',		icon:FoodMenu},
					{label:'Events',	link:'frontend/Events',		icon:Calendar},
					{label:'Contact',	link:'frontend/Contact',	icon:Contact},
					{label:'Hire',		link:'frontend/Hire', 		icon:Contact},
					{label:'Club',		page:'club',				icon:Contact},
				]
			}
		};
	}

	backendNavContent()
	{
		return [
			...super.backendNavContent(),
			{label:'Staff',		route:'/admin/staffResources',	icon:PeopleCircle},
		];
	}
};

function menuItemTitleColour(palette,productType,section)
{
	if (section.title?.startsWith('Cocktails @ Bar Cactus'))
		return palette.cactus;
	if (section.title?.startsWith('Cocktails @ Street Bar'))
		return palette.food;

//FIXME probably should use calculateProductType on the section. Need the whole menu for this?? 
//OPTION 1:
//1. Pass through whole menu via P or access via a MenuProvider.
//   Pass through location
//   Call calculateProductType()
//2. Precalculate productType for everything. Maybe add as 'calculatedProductType'
//3. Pass productType down via P (is this already done?)

	else if (productType == 'food')
		return palette.food;
	else
		return palette.feature;
}

function menuNavButtonColour(palette,type:string)
{
	switch(type) {
		case 'food': return palette.food;
		case 'drinks': return palette.drinks;
	}
	return 'inherit';
}

